import styled from 'styled-components';

export const ContainerInternoProps = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  margin-left: 10px;
`;
